export default __webpack_public_path__ + "static/media/clusterconfiguration_openapi.3413ade0.yaml";